import { Component, Input, OnInit, Output, EventEmitter, Optional } from '@angular/core';
import { ControlContainer, ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule, Validators } from '@angular/forms';
import { TextInput, Warning } from '../../../../../utils/models/input.interface';
import { returnTextWarning, returnWarningIcon, returnColorWarning } from '../../../functions/utilities.service';
import { CommonModule } from '@angular/common';
import { TooltipComponent } from '../../miscelanea/tooltip/tooltip.component';
import { MatIconModule } from '@angular/material/icon';
import { WarningInputInduxtryDirective } from 'src/app/shared/directives/warning-input-induxtry/warning-input-induxtry.directive';
import { MatFormFieldModule, MatSuffix } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconButton } from '@angular/material/button';

@Component({
  selector: 'text-input',
  templateUrl: './text-input.component.html',
  styleUrls: ['./text-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: TextInputComponent,
    },
  ],
  standalone: true,
  imports: [
    MatIconButton,
    MatSuffix,
    CommonModule, 
    TooltipComponent, 
    MatIconModule, 
    MatInputModule, 
    WarningInputInduxtryDirective, 
    MatFormFieldModule, 
    FormsModule,
  ]  
})
export class TextInputComponent implements OnInit, ControlValueAccessor{
  warningIconTextInput = returnWarningIcon;
  colorWarningTextInput = returnColorWarning;
  textWarningTextInput = returnTextWarning;

  @Input() textInput: TextInput;
  @Input() textField: boolean;


  @Output() valueEmitter: EventEmitter<string> = new EventEmitter<string>();
  @Output() onChangeValueEmitter: EventEmitter<string> = new EventEmitter<string>();
  @Output() focusOutEmitter: EventEmitter<string> = new EventEmitter<string>();

  @Input() warning: Warning;

  @Input() formControlName: string;

  constructor(@Optional() private controlContainer: ControlContainer) { }


  writeValue(value: any): void {
    this.textInput.value = value;
  }

  onChange: (_: any) => void = () => { }

  onTouched = (value: unknown) => {
    return value;
  };

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(onTouched: any): void {
    this.onTouched = onTouched;
  }

  ngOnInit(): void {
    if(this.controlContainer) {
      const control = this.controlContainer.control.get(this.formControlName);
      if (control && control.hasValidator(Validators.required)) {
        if (this.textInput && this.textInput.required) {
          this.textInput.required.active = true;
        }
      }
    }
  }

  setValue() {
    this.onChange(this.textInput.value);
    this.valueEmitter.emit(this.textInput.value);
  }

  setValueOnChange() {
    this.onChangeValueEmitter.emit(this.textInput.value);
  }

  handleFocusOut(): void {
    this.focusOutEmitter.emit(this.textInput.value);
  }
}
